import { createSlice } from "@reduxjs/toolkit";
import {
  fetchDatastreamList,
  fetchDatastreamVersions,
} from "./dashboard.thunk";

const defaultSelectedDS = { datastream: null, versions: [] };

const datastreamState = {
  selectedDS: defaultSelectedDS,
  list: [],
  isLoadingList: false,
};

const datastreamSlice = createSlice({
  name: "datastream",
  initialState: datastreamState,
  reducers: {
    setSelected: (state, action) => {
      state.selectedDS = { ...state.selectedDS, ...action.payload };
    },
    resetSelected: (state) => {
      state.selectedDS = defaultSelectedDS;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDatastreamList.pending, (state) => {
        state.isLoadingList = true;
      })
      .addCase(fetchDatastreamList.fulfilled, (state, action) => {
        state.list = action.payload;
        state.isLoadingList = false;
      })
      .addCase(fetchDatastreamList.rejected, (state) => {
        state.list = [];
        state.isLoadingList = false;
      })
      .addCase(fetchDatastreamVersions.fulfilled, (state, action) => {
        state.selectedDS = { ...state.selectedDS, versions: action.payload };
      })
      .addCase(fetchDatastreamVersions.rejected, (state) => {
        state.selectedDS = { ...state.selectedDS, versions: [] };
      });
  },
});

export const { setSelected, resetSelected } = datastreamSlice.actions;
export default datastreamSlice.reducer;
